import { render, staticRenderFns } from "./footer-seo.vue?vue&type=template&id=5fe2645f&scoped=true&"
import script from "./footer-seo.vue?vue&type=script&lang=js&"
export * from "./footer-seo.vue?vue&type=script&lang=js&"
import style0 from "./footer-seo.vue?vue&type=style&index=0&id=5fe2645f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe2645f",
  null
  
)

export default component.exports